@if (on==='form') {
  @if (control.field.condensed) {
    <div class="condensed">
        <div class="condensed-label">{{control.field.label}}</div>
        <div class="condensed-value">
            <span [attr.data-field]="control.field.name">{{formatToLocal(control.value)}}</span>
            <div class="condensed-hint">
                @if (control.field.hint) {
                    <mat-icon [matTooltip]="control.field.hint" matTooltipPosition="above">help</mat-icon>
                }
            </div>
        </div>
    </div>
  } @else {
    <mat-form-field class="full-width" floatLabel="always" style="height: 74px">
      <mat-label>{{control.field.label}}</mat-label>
      <input matInput
        [matDatepicker]="datePicker"
        [value]="calendarDate()"
        (dateChange)="applyChosenDate($event)"
        [errorStateMatcher]="showControlErrors"
        [disabled]="control.disabled"
        [readonly]="!isEditable()"
        id="{{control.field.name}}-dateField"
        placeholder="DD/MM/YYYY"
        autocomplete="off">
      @if (isEditable()) {
        <mat-datepicker-toggle matIconSuffix [for]="datePicker">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
      }
      @if (control.field.hint) {
          <mat-icon matSuffix color="primary" [matTooltip]="control.field.hint">info</mat-icon>
      }
      <mat-datepicker #datePicker></mat-datepicker>
      <mat-error style="margin-top:-5px">
        <app-form-error [control]="control"></app-form-error>
      </mat-error>
    </mat-form-field>
  }
}

@if (on!=='form') {
  <div>
    @if (!control.field.readonly && !control.field.disable) {
      <div class="grid-date">
        <input class="grid-date-input"
          [matDatepicker]="gridDatePicker"
          [value]="calendarDate()"
          (dateChange)="applyChosenDate($event)"
          [attr.data-field-name]="control.field.name"
          [ngClass]="{error: control.invalid && control.touched}"
          [matTooltip]="control.getErrorMessage()"
          placeholder="DD/MM/YYYY"
          autocomplete="off">
        <mat-datepicker-toggle [for]="gridDatePicker">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #gridDatePicker></mat-datepicker>
      </div>
    }
    @if (control.field.readonly || control.field.disable) {
      <span>{{formatToLocal(control.value)}}</span>
    }
  </div>
}
